<template>
  <div class="richgo-guide">
    <h1>리치고 사용법 가이드 영상</h1>
    <v-container>
      <youtube-swiper></youtube-swiper>
    </v-container>

    <div class="video-wrapper" v-for="url in urlList" :key="url">
      <iframe
        class="video"
        width="910"
        height="512"
        :src="url"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
import YoutubeSwiper from "../components/YoutubeSwiper";

export default {
  data() {
    return {
      urlList: [
        "https://www.youtube.com/embed/i_h1meLp6AM",
        "https://www.youtube.com/embed/lWc_ZFnz5OE",
        "https://www.youtube.com/embed/5AtUNjxqPw4",
        "https://www.youtube.com/embed/z7m94g6b5sw",
        "https://www.youtube.com/embed/VjZkU0XwIWk",
        "https://www.youtube.com/embed/zSJpK4vBpms"
      ]
    };
  },
  components: {
    YoutubeSwiper
  }
};
</script>

<style scoped>
.richgo-guide {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

.richgo-guide > h1 {
  padding: 20px 0 5px;
}

.richgo-guide > h3 {
  padding-bottom: 20px;
  color: gray;
}

.video-wrapper {
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  margin: 30px 0;
}

.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>